import RegistrationScreen from "@/screens/onboarding/RegistrationScreen"
import { useLocalSearchParams } from "expo-router"
import { useDidPreQual } from "@/stores/preQual"
import { useViewedCallback } from "@/analytics/react"
import { setStatusBarStyle } from "@/stores/statusBarStyle"
import * as registerEvents from "@/analytics/events/register"
import { getUtm, updateUtm, useUtmStore } from "@/stores/utm"
import { useEffect } from "react"

interface RegisterCopyProps {
  title: string
  body: string
  subTitle?: string
  icon?: string
}

/* We might want to in the future if this gets used move it to server */
const PRESETS: Record<string, RegisterCopyProps> = {
  default: {
    title: "Become a |Member|",
    body: "Join over 50k fix & flip members today!\nFree tools. Fast funding. More profits. ",
  },
  preQual: {
    title: "See your |Loan options| now",
    body: "Join over 50k fix & flip members today!\nFree tools. Fast funding. More profits. ",
  },

  ads: {
    title: "Become a |Member| to see your options",
    body: "Join over 50k fix & flip members today!\nFree tools. Fast funding. More profits. ",
  },
  zeroGravity: {
    title: "|Zero Gravity:|\nNever worry about cashflow again",
    body: "No upfront fees, up to 96% LTC, no payments for 6 months",
    subTitle: "|Register now to check your eligibility:",
    icon: "rocket",
  },
  events: {
    title: "Thanks for joining us at our event!",
    body: "Join over 50k fix & flip members today!\nFree tools. Fast funding. More profits.",
  },
}

export default function () {
  const { title, body, subtitle, key } = useLocalSearchParams()
  const isPreQualFlow = useDidPreQual()
  const utm = useUtmStore()

  // In order, key=XXX pri1, utm_medium on session that matches PRESET pri 2, default
  const presetKey = key
    ? (key as string)
    : utm.utmMedium && PRESETS[utm.utmMedium]
      ? utm.utmMedium
      : isPreQualFlow
        ? "preQual"
        : "default"

  const preset = PRESETS[presetKey]

  console.log(presetKey, preset, utm.utmMedium)

  useEffect(() => {
    // Check for utm params from event registration
    void fetch("https://events-register.backflip.com/lookup").then(
      async (res) => {
        const json: { utmParams: Record<string, string> } = await res.json()
        if (json.utmParams) {
          function convertKeysToCamelCase(obj: Record<string, string>) {
            const toCamelCase = (key: string) =>
              key.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())

            return Object.keys(obj).reduce<Record<string, string>>(
              (acc, key) => {
                const camelKey = toCamelCase(key)
                acc[camelKey] = obj[key]
                return acc
              },
              {}
            )
          }

          const params = convertKeysToCamelCase(json.utmParams)

          console.log("EVENT REGISTRATION UTM FOUND", params)
          const existingUtm = getUtm()
          updateUtm({ ...existingUtm, ...params })
        }
      }
    )
  }, [])

  useViewedCallback(() => {
    setStatusBarStyle("light")
    registerEvents.registerViewed(presetKey)
  }, [presetKey])

  return (
    <RegistrationScreen
      title={
        (title as string) ||
        preset.title ||
        "|Zero Gravity:|\nNever worry about cashflow again"
      }
      body={
        (body as string) ||
        preset.body ||
        "No upfront fees, up to 96% LTC, no payments for 6 months"
      }
      subTitle={(subtitle as string) || preset.subTitle}
      icon={preset.icon}
    />
  )
}
